// Uncomment this line to use CSS modules
// import styles from './app.module.css';

import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useMode } from '@schamburg-web/components';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import Layout from './layout';

export function App() {
  const { mode } = useMode();

  const TRACKING_ID = 'G-CKP7Y1S2XF'; // OUR_TRACKING_ID (FROM LCDOT)
  ReactGA.initialize(TRACKING_ID);

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: '/', title: 'Main Page' });
  }, []);

  useEffect(() => {
    // Ensure the body has the correct class for dark mode
    document.body.classList.toggle('light', mode === 'light');
    document.body.classList.toggle('dark', mode === 'dark');
  }, [mode]);

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: mode === 'dark' ? 'dark' : 'light',
        },
      }),
    [mode]
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Layout />
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
